export default __webpack_public_path__ + "static/media/Vasterbotten.206e5bea.png";